// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Group 3804.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */

body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  color: #FAC8FF;
}
  .welcome{
    margin-top: 10px;
    margin-left: 100px;
    color: white;
    width: 40%;
    height: 30px;
  }
  /* .main-login{
    display: flex;
    flex-direction: column;
    align-items: center;
  } */
  .checkbox{
    margin-top: 3px;
    font-size: 15px;
    font-family: 'Roboto', sans-serif;
    color: #FAC8FF;
  }
  .avatar{
    width: 20%;
    margin: 20px;
  }
  .acce{
    width: 50%;
  }
  .user-img{
    width: 10%;
    margin-top: 15px;
    height: 15px;
  }
  .pass-img{
    width: 7%;
    margin-right: 10px;
    margin-top: 18px;
    height: 15px;
  }
  .main-L{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace 'background.jpg' with your image file */
    background-size: cover;
    background-position: center;
    min-height: calc(100vh - 20px);
  }
  .login-container {
    position: absolute;
    top: 60%;
    left: 80%;
    width: 18%;
    height: 10%;
    /* height: 20%;
    width: 20%; */
    transform: translate(-50%, -50%);
    background: rgba(41, 5, 63, 1);
    /* border: 1px solid white; */
    padding: 5px;
    border-radius: 25px;   
    align-items: center;
    /* margin-top: 20px; */
    color : white;
    font-size: 22px;
    font-family: Graphik;
    font-weight: 400;
    border: none;
  }

  .title-login{
    transform: translate(215%, 200%);
    display: flex;
   flex-direction: column;
    /* position: absolute; */
    width: 30%;
    height: 10%;
    top: 60%;
    left: 80%;
   /* display: flex;
   flex-direction: column;
   max-width: 345px;
   margin-left: 142vh;
   padding-top: 130px; */
  }
 
  
.user-tag{
  display: flex;
  margin-top: 6px;
    flex-direction: row;
    width: 100%;
}
  
  .form-group label {
    font-size: 14px;
    width: 100%;
    margin-bottom: 5px;
    font-weight: 200;
    font-style: Graphik;
  }
  
  .form-group input {
    padding: 10px;
    font-size: 16px;
    border: none;
    margin-bottom: 10px;
    background-color: transparent;
    color: rgba(41, 5, 63, 1);
    width: 230px;
    border-bottom: 1px solid gray;
  }
  .form-group input:focus{
    color:rgba(41, 5, 63, 1);
    padding: 10px;
    font-size: 16px;
    border: none;
    margin-bottom: 10px;
    border-bottom: 1px solid gray;
    background-color: transparent;  
    outline: none; 
  }
    .password{
      text-decoration: none;
      font-family: 'Roboto', sans-serif;
      font-size: 12px;
      margin-right: 4px;
      color: rgba(41, 5, 63, 1);
    }
  .remember-forgot {
    display: flex;
    margin-top: 10px;
    margin-left: 130px;
  }
  .form-group input::placeholder{
    color: gray;
  }
  .button-l{
    background: rgba(41, 5, 63, 1);
    width: 90%;
    height: 45px;
    border-radius: 20px;
    margin-top: 20px;
    color : white;
    font-size: 17px;
    font-family: Graphik;
    font-weight: 400;
    border: none;
  }
  
  .remember-forgot label {
    font-size: 14px;
  }
  
  .watermark {
    position: absolute;
    bottom: 0;
    right: 0;
    padding-right: 530px;
    color: white;
    font-size: 12px;
    opacity: 0.5;
  justify-content: center;
  align-items: center;
  }
  .login-label{
    color: rgba(41, 5, 63, 1);
    line-height: 10px;
    font-weight: 500;
    font-size: 14px;
    font-family: Graphik;
    margin-top: 20px;
    margin-right: 200px;
  }
 .azureicon{
  width:27px;
  margin-right: 10px;
  margin-bottom: 3px;
 }
 .button-login{
   background: rgba(41, 5, 63, 1);
   width: 90%;
   height: 45px;
   border-radius: 20px;
   margin-top: 20px;
   color : white;
   font-size: 17px;
   font-family: Graphik;
   font-weight: 400;
   border: none;
 }`, "",{"version":3,"sources":["webpack://./src/login.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,cAAc;AAChB;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;EACd;EACA;;;;KAIG;EACH;IACE,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,cAAc;EAChB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,yDAAiD,EAAE,kDAAkD;IACrG,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX;iBACa;IACb,gCAAgC;IAChC,8BAA8B;IAC9B,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gCAAgC;IAChC,aAAa;GACd,sBAAsB;IACrB,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;GACV;;;;wBAIqB;EACtB;;;AAGF;EACE,aAAa;EACb,eAAe;IACb,mBAAmB;IACnB,WAAW;AACf;;EAEE;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,aAAa;EACf;IACE;MACE,qBAAqB;MACrB,iCAAiC;MACjC,eAAe;MACf,iBAAiB;MACjB,yBAAyB;IAC3B;EACF;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,YAAY;EACd,uBAAuB;EACvB,mBAAmB;EACnB;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;CACD;EACC,UAAU;EACV,kBAAkB;EAClB,kBAAkB;CACnB;CACA;GACE,8BAA8B;GAC9B,UAAU;GACV,YAAY;GACZ,mBAAmB;GACnB,gBAAgB;GAChB,aAAa;GACb,eAAe;GACf,oBAAoB;GACpB,gBAAgB;GAChB,YAAY;CACd","sourcesContent":["/* Login.css */\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Roboto', sans-serif;\r\n  color: #FAC8FF;\r\n}\r\n  .welcome{\r\n    margin-top: 10px;\r\n    margin-left: 100px;\r\n    color: white;\r\n    width: 40%;\r\n    height: 30px;\r\n  }\r\n  /* .main-login{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  } */\r\n  .checkbox{\r\n    margin-top: 3px;\r\n    font-size: 15px;\r\n    font-family: 'Roboto', sans-serif;\r\n    color: #FAC8FF;\r\n  }\r\n  .avatar{\r\n    width: 20%;\r\n    margin: 20px;\r\n  }\r\n  .acce{\r\n    width: 50%;\r\n  }\r\n  .user-img{\r\n    width: 10%;\r\n    margin-top: 15px;\r\n    height: 15px;\r\n  }\r\n  .pass-img{\r\n    width: 7%;\r\n    margin-right: 10px;\r\n    margin-top: 18px;\r\n    height: 15px;\r\n  }\r\n  .main-L{\r\n    background-image: url('./images/Group\\ 3804.png'); /* Replace 'background.jpg' with your image file */\r\n    background-size: cover;\r\n    background-position: center;\r\n    min-height: calc(100vh - 20px);\r\n  }\r\n  .login-container {\r\n    position: absolute;\r\n    top: 60%;\r\n    left: 80%;\r\n    width: 18%;\r\n    height: 10%;\r\n    /* height: 20%;\r\n    width: 20%; */\r\n    transform: translate(-50%, -50%);\r\n    background: rgba(41, 5, 63, 1);\r\n    /* border: 1px solid white; */\r\n    padding: 5px;\r\n    border-radius: 25px;   \r\n    align-items: center;\r\n    /* margin-top: 20px; */\r\n    color : white;\r\n    font-size: 22px;\r\n    font-family: Graphik;\r\n    font-weight: 400;\r\n    border: none;\r\n  }\r\n\r\n  .title-login{\r\n    transform: translate(215%, 200%);\r\n    display: flex;\r\n   flex-direction: column;\r\n    /* position: absolute; */\r\n    width: 30%;\r\n    height: 10%;\r\n    top: 60%;\r\n    left: 80%;\r\n   /* display: flex;\r\n   flex-direction: column;\r\n   max-width: 345px;\r\n   margin-left: 142vh;\r\n   padding-top: 130px; */\r\n  }\r\n \r\n  \r\n.user-tag{\r\n  display: flex;\r\n  margin-top: 6px;\r\n    flex-direction: row;\r\n    width: 100%;\r\n}\r\n  \r\n  .form-group label {\r\n    font-size: 14px;\r\n    width: 100%;\r\n    margin-bottom: 5px;\r\n    font-weight: 200;\r\n    font-style: Graphik;\r\n  }\r\n  \r\n  .form-group input {\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border: none;\r\n    margin-bottom: 10px;\r\n    background-color: transparent;\r\n    color: rgba(41, 5, 63, 1);\r\n    width: 230px;\r\n    border-bottom: 1px solid gray;\r\n  }\r\n  .form-group input:focus{\r\n    color:rgba(41, 5, 63, 1);\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border: none;\r\n    margin-bottom: 10px;\r\n    border-bottom: 1px solid gray;\r\n    background-color: transparent;  \r\n    outline: none; \r\n  }\r\n    .password{\r\n      text-decoration: none;\r\n      font-family: 'Roboto', sans-serif;\r\n      font-size: 12px;\r\n      margin-right: 4px;\r\n      color: rgba(41, 5, 63, 1);\r\n    }\r\n  .remember-forgot {\r\n    display: flex;\r\n    margin-top: 10px;\r\n    margin-left: 130px;\r\n  }\r\n  .form-group input::placeholder{\r\n    color: gray;\r\n  }\r\n  .button-l{\r\n    background: rgba(41, 5, 63, 1);\r\n    width: 90%;\r\n    height: 45px;\r\n    border-radius: 20px;\r\n    margin-top: 20px;\r\n    color : white;\r\n    font-size: 17px;\r\n    font-family: Graphik;\r\n    font-weight: 400;\r\n    border: none;\r\n  }\r\n  \r\n  .remember-forgot label {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .watermark {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    padding-right: 530px;\r\n    color: white;\r\n    font-size: 12px;\r\n    opacity: 0.5;\r\n  justify-content: center;\r\n  align-items: center;\r\n  }\r\n  .login-label{\r\n    color: rgba(41, 5, 63, 1);\r\n    line-height: 10px;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    font-family: Graphik;\r\n    margin-top: 20px;\r\n    margin-right: 200px;\r\n  }\r\n .azureicon{\r\n  width:27px;\r\n  margin-right: 10px;\r\n  margin-bottom: 3px;\r\n }\r\n .button-login{\r\n   background: rgba(41, 5, 63, 1);\r\n   width: 90%;\r\n   height: 45px;\r\n   border-radius: 20px;\r\n   margin-top: 20px;\r\n   color : white;\r\n   font-size: 17px;\r\n   font-family: Graphik;\r\n   font-weight: 400;\r\n   border: none;\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
